import React, { CSSProperties, ReactNode } from 'react';
import './ScrollableContainer.css';

interface ScrollableContainerProps {
    children: ReactNode;
    className?: string;
    style?: CSSProperties;
}

/**
 * 可以包裹内容进行滚动
 * **/
const ScrollableContainer: React.FC<ScrollableContainerProps> = ({ children, className = '', style = {} }) => {
    return (
        <div className={`scrollable-container ${className}`} style={style}>
            {children}
        </div>
    );
};

export default ScrollableContainer;
